import React from 'react';
import BlogFAQSection from '../blog/BlogFAQSection';
import StructuredDataFAQ from '@/components/seo/StructuredDataFAQ';
import { coachingNuernbergFAQData } from '@/data/faq/coaching-nuernberg-faq';

const CoachingNuernbergFAQ = () => {
  const faqItems = coachingNuernbergFAQData;

  return (
    <section id="faq" className="section-spacing bg-white">
      <StructuredDataFAQ faqItems={faqItems} pageName="Coaching Nürnberg" />
      <div className="container max-w-4xl">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Häufige Fragen
          </span>
          <h2 className="animate-fade-in mb-6" style={{ animationDelay: '100ms' }}>
            Coaching in der Region Nürnberg
          </h2>
          <p className="text-muted-foreground text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '200ms' }}>
            Antworten auf die wichtigsten Fragen zu Coaching-Angeboten in Nürnberg, Roth und Umgebung.
          </p>
        </div>
        
        <BlogFAQSection 
          items={faqItems} 
          title="" 
        />
      </div>
    </section>
  );
};

export default CoachingNuernbergFAQ;
